import wagonRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  storageHandler,
  $$wagon,
  toaster,
) => {
  $transitions.onSuccess({
    entering: wagonRoutes.home.path,
  }, (trans) => {
    if (storageHandler.get('consult.wagon.myWagon')) {
      $$wagon.data.myWagon = storageHandler.get('consult.wagon.myWagon')
    } else {
      $$wagon.data.myWagon = $$wagon.new.search()
    }

    if (storageHandler.get('consult.wagon.mySearchedWagons')) {
      $$wagon.data.mySearchedWagons = storageHandler.get('consult.wagon.mySearchedWagons')
    } else {
      $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    }
  })

  $transitions.onSuccess({
    exiting: wagonRoutes.home.path,
  }, (trans) => {
    // if (!trans.to().redirectTo) {
    storageHandler.save('consult.wagon.myWagon', $$wagon.data.myWagon)
    storageHandler.save('consult.wagon.mySearchedWagons', $$wagon.data.mySearchedWagons)
    $$wagon.data.myWagon = null
    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    // }
  })

  $transitions.onSuccess({
    entering: wagonRoutes.details.path,
  }, async (trans) => {
    const wagonId = $$wagon.local.getCurrentId()

    try {
      $$wagon.data.myWagon = await $$wagon.request.getById(wagonId)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onBefore({
    exiting: wagonRoutes.details.path,
  }, async (trans) => {
    $$wagon.data.myWagon = null
  })

  $transitions.onSuccess({
    entering: wagonRoutes.edit.path,
  }, async (trans) => {
    const wagonId = $$wagon.local.getCurrentId()
    try {
      const wagon = await $$wagon.request.getById(wagonId)
      const formattedWagon = $$wagon.format.user(wagon)
      $$wagon.data.myWagon = formattedWagon
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    from: wagonRoutes.edit.path,
  }, async (trans) => {
    const wagonId = $$wagon.local.getCurrentId()
    try {
      const wagon = await $$wagon.request.getById(wagonId)
      if ($$wagon.data.mySearchedWagons) {
        const index = $$wagon.data.mySearchedWagons
          .findIndex(value => value.id === wagon.id)

        $$wagon.data.mySearchedWagons[index] = wagon
      }
    } catch (error) {
      toaster.error(error)
    }
  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/wagon/wagon.run.js